import { useIsCompactScreen } from '@/styles/hooks/useIsCompactScreen';

import { useEntityDiagramContext } from '../contexts/entityDiagram.context';

export function useIsCompactLayout() {
  const isCompactScreen = useIsCompactScreen();
  const { state } = useEntityDiagramContext();

  return isCompactScreen || state.derivedData.isSummaryPanelOpen;
}
